module.exports = __webpack_public_path__ + "static/media/tangocard.50ea4bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Dashboard/parts/ea-calculator-only/tangocard.png
// module id = 2797
// module chunks = 0